(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const variantsEl = document.querySelector('[id^="NazVariants-"]');
    if (!variantsEl) return;

    const variants = JSON.parse(variantsEl.textContent || "[]");

    // You confirmed: option1 = Color, option2 = Size
    const COLOR_INDEX = 0;
    const SIZE_INDEX = 1;

    function getSelectedColor() {
      // Since your option name is EXACTLY "Color"
      const colorRadio = document.querySelector('input[name="Color"]:checked');
      if (colorRadio) return colorRadio.value;

      const colorSelect = document.querySelector('select[name="options[Color]"]');
      if (colorSelect) return colorSelect.value;

      // fallback: current variant id
      const idInput = document.querySelector('input[name="id"]');
      if (idInput) {
        const current = variants.find(v => String(v.id) === String(idInput.value));
        if (current) return current.options[COLOR_INDEX];
      }

      return null;
    }

    function findVariant(color, size) {
      if (!color || !size) return null;
      return variants.find(v => {
        const opts = v.options || [];
        return opts[COLOR_INDEX] === color && opts[SIZE_INDEX] === size;
      }) || null;
    }

    function setTooltip(labelEl, text) {
      const tip = labelEl.querySelector("[data-naz-stock]");
      if (tip) tip.textContent = text;
    }

    function updateTooltips() {
      const color = getSelectedColor();

      document.querySelectorAll(".naz-size-label[data-size]").forEach(label => {
        const size = label.getAttribute("data-size");
        const v = findVariant(color, size);

        if (!v) return setTooltip(label, "Unavailable");

        const qty = typeof v.inventory_quantity === "number" ? v.inventory_quantity : 0;

        if (!v.available || qty <= 0) setTooltip(label, "Out of Stock");
        else setTooltip(label, `In Stock : ${qty} available`);
      });
    }

    updateTooltips();

    document.addEventListener("change", function (e) {
      if (e.target.closest("product-info")) setTimeout(updateTooltips, 50);
    });

    document.addEventListener("mouseenter", function (e) {
      if (e.target.closest(".naz-size-label")) updateTooltips();
    }, true);
  });
})();


